import { useMemo, useSyncExternalStore } from 'react';
import type { LobbySession } from './LobbySession.js';
import type { GameEndView } from '../game-end/types.js';

export interface UseGameEndSessionResult {
  /** Non-null only while the session is in the GameEnd phase. */
  view: GameEndView | null;
  onBackToLobby: () => void;
}

export function useGameEndSession(session: LobbySession): UseGameEndSessionResult {
  const snapshot = useSyncExternalStore(
    (cb) => session.subscribe(cb),
    () => session.getSnapshot(),
  );
  const onBackToLobby = useMemo(
    () => () => session.sendBackToLobby(),
    [session],
  );
  return { view: snapshot.gameEndView, onBackToLobby };
}
